export default "__VITE_ASSET__ed2d1387__"